<template>
  <div class="captcha-wrapper">
    <!-- 无痕验证不需要显示区域，只需要一个隐藏的挂载点 -->
    <div :id="elementId" style="display: none;"></div>
  </div>
</template>

<script>
export default {
  name: 'AliyunCaptcha',
  props: {
    sceneId: { type: String, required: true },
    // 无痕验证必须是 popup 模式
    mode: { type: String, default: 'popup' },
    // 触发验证的按钮选择器（必填）
    button: { type: String, required: true },
    language: { type: String, default: 'cn' }
  },
  data() {
    return {
      elementId: `captcha-${Math.random().toString(36).substr(2, 9)}`,
      instance: null,
      verifyParam: null,
      isReady: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => this.init(), 100);
    });
  },
  beforeDestroy() {
    if (this.instance && this.instance.destroy) {
      this.instance.destroy();
    }
  },
  methods: {
    init() {
      if (!window.initAliyunCaptcha) {
        // console.error('AliyunCaptcha.js 未加载');
        return;
      }

      // 检查按钮是否存在
      const btn = document.querySelector(this.button);
      if (!btn) {
        // console.error('触发按钮不存在:', this.button);
        return;
      }

      const config = {
        SceneId: this.sceneId,
        mode: 'popup',           // 无痕验证必须用 popup
        element: `#${this.elementId}`,  // 隐藏元素
        button: this.button,      // 触发按钮选择器
        captchaVerifyCallback: this.captchaVerifyCallback,
        onBizResultCallback: this.onBizResultCallback,
        getInstance: this.getInstance,
        language: this.language,
        // 无痕验证不需要 slideStyle
        onError: this.onError
      };

      console.log('无痕验证初始化:', config);

      try {
        window.initAliyunCaptcha(config);
      } catch (e) {
        // console.error('初始化异常:', e); 
      }
    },
    getInstance(inst) {
      // console.log('实例获取成功:', inst);
      this.instance = inst;
      this.isReady = true;
      this.$emit('ready', inst);
    },
    async captchaVerifyCallback(captchaVerifyParam) {
      console.log('无痕验证回调:', captchaVerifyParam);
      this.verifyParam = captchaVerifyParam;
      this.$emit('verify', captchaVerifyParam);
      
      // 返回成功，业务验证由父组件处理
      return { captchaResult: true, bizResult: true };
    },
    onBizResultCallback(bizResult) {
      console.log('业务结果:', bizResult);
      this.$emit('biz-result', bizResult);
    },
    onError(error) {
      console.error('验证码错误:', error);
      this.$emit('error', error);
    },
    // 手动触发验证（如果需要）
    verify() {
      if (this.instance && this.instance.verify) {
        this.instance.verify();
      }
    },
    getVerifyParam() {
      return this.verifyParam;
    },
    reset() {
      this.verifyParam = null;
    }
  }
}
</script>

<style scoped>
.captcha-wrapper {
  display: none; /* 无痕验证不需要显示 */
}
</style>